import { useState } from 'react'
import SearchBtn from '../../component/common/button/SearchBtn';
import NewDataGrid from '../../component/common/dataGrid/NewDataGrid';
import Main from '../../component/Main';

const AuditLog = () => {
	const [searchParams, setSearchParams] = useState({
		searchFromdate: new Date((new Date()).getTime() + 1000 * 60 * 60 * 9).toISOString().split('T')[0],
		searchTodate: new Date((new Date()).getTime() + 1000 * 60 * 60 * 9).toISOString().split('T')[0],
		searchGubun: '',
		searchCnt: '0',
	});

	const searchParamsAdditional = {
	};

	const handleInputChange = (e) => {
		const { name, value } = e.target;
		const newParams = {
			...searchParams,
			[name]: value
		};
		setSearchParams(newParams);
	};

	const dataHead = ['접근 ID', '접근일시', '접근 IP', '수행업무', '접근 서비스', '조회건수']; //수정 필요
	const dataColumn = ['PER_INFO_ID', 'PER_INFO_DTM', 'PER_INFO_IP', 'PER_INFO_WORK', 'PER_INFO_PGM', 'PER_INFO_CNT']; // 수정필요
	const apiCall = '/commonapi/audit/selectAUDITLOGList.do';
	const apiCntCall = '/commonapi/audit/selectAUDITLOGListCnt.do';
	const excelFileName = '감사 로그';
	const excelHead = [];

	const propsInfo = {
		dataHead: dataHead,
		dataColumn: dataColumn,
		apiCall: apiCall,
		apiCntCall: apiCntCall,
		excelFileName: excelFileName,
		excelHead: excelHead
	}

	const [state, setState] = useState({
		dataList: [],
		isSearched: false,
		isLoading: false
	})

	const [pageInfo, setPageInfo] = useState({
		paginationTF: true,
		currentPage: 1,
		itemsPerPage: 50,
		totalItems: 0
	});

	return (
        <Main>
			<div className='flex flex-col w-full h-full'>
				<div className="com-search">
					<table>
						<colgroup>
							<col width="9%" />
							<col width="32%" />
							<col width="9%" />
							<col width="20%" />
							<col width="9%" />
							<col width="20%" />
						</colgroup>
						<tbody>
							<tr>
								<th>검색 기간</th>
								<td>
									<input
									type="date"
									name="searchFromdate"
									value={searchParams.searchFromdate}
									onChange={handleInputChange}
									/>
									&nbsp;~&nbsp;
									<input
									type="date"
									name="searchTodate"
									value={searchParams.searchTodate}
									onChange={handleInputChange}
									min={searchParams.searchFromdate}
									/>
								</td>
								<th>수행업무</th>
								<td>
									<select
									id="searchCnt"
									name="searchCnt"
									className='w-full'
									value={searchParams.searchCnt}
									onChange={handleInputChange}
									>
									<option value="0">전체</option>
									<option value="1">조회</option>
									<option value="2">입력</option>
									<option value="3">삭제</option>
									<option value="4">수정</option>
									</select>
								</td>
								<th>사용자 ID</th>
								<td>
									<input
									type="text"
									id="searchGubun"
									className='input_style'
									name="searchGubun"
									value={searchParams.searchGubun}
									onChange={handleInputChange}
									/>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<SearchBtn
					propsInfo={propsInfo}
					state={state}
					setState={setState}
					searchParams={searchParams}
					searchParamsAdditional={searchParamsAdditional}
					pageInfo={pageInfo}
					setPageInfo={setPageInfo}
				/>
				<NewDataGrid
					propsInfo={propsInfo}
					state={state}
					pageInfo={pageInfo}
					setPageInfo={setPageInfo}
				/>
			</div>
		</Main>
	)
}

export default AuditLog;